<template>
  <div class="loading-container">
    <div class="relative center-content">
      <!-- <img
        src="../assets/images/Ellipse15.webp"
        alt=""
        class="absolute shadow1-img"
      /> -->
      <img
        src="../assets/images/ServicesElipse.webp"
        alt=""
        class="absolute shadow2-img"
      />
      <div class="center-logo">
        <v-img
          lazy
          src="../assets/images/OPLogo.png"
          alt="logo"
          :style="{ width: '276px', height: '301px' }"
        ></v-img>
        <div class="text-center">Getting things ready...</div>
        <div class="loading-bar-container">
          <div class="loading-bar"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup></script>

<style scoped>
  .loading-bar-container {
  width: 100%;
  height: 4px;
  margin-top: 16px;
  background-color: #e0e0e0;
  border-radius: 4px;
  overflow: hidden;
}

.loading-bar {
  height: 100%;
  width: 0;
  background-color: #3B4C96;
  animation: loadBar 2s infinite;
}

@keyframes loadBar {
  0% {
    width: 0%;
  }
  50% {
    width: 100%;
  }
  100% {
    width: 0%;
  }
}
.loading-container {
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  max-width: 1260px;
  overflow: hidden;
  margin: auto;
}

.relative {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.center-content {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.center-logo {
  position: absolute;
  z-index: 1;
}

.shadow1-img{
  width: 670px;
  top: 0;
  height: 706px;
}
@media(min-width:1024px){
  .shadow1-img{
    top:-6%;
  }
  .shadow2-img{
    top:0%;right:-10%;
  } 
}

@media(max-width:600px){
  .shadow1-img{
    width: 370px;
    top: 0;
    height: 406px;
  }
  .shadow2-img{
    width: 300px;
    height: 468px;
    top:4%;right:0%;
  }
}
</style>
